
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Resortnearakolaforfamily() {



  const cardData =
  {
    keyword: ' Resorts Near Akola for Family',
    heading:  'Woodland Escape: Resorts Near Akola for Family',
    headingDescription: 'Woodland Escape Resort, one of the finest resorts near Akola for family, offers a perfect getaway where comfort, fun, and nature come together beautifully. Nestled amidst lush greenery and peaceful forest surroundings, the resort provides a safe and relaxing environment ideal for family vacations, weekend breaks, or special celebrations. Families can enjoy spacious lawns, cozy cottages, a refreshing swimming pool, and a variety of recreational activities like nature walks, archery, cycling, and outdoor games for all age groups. With delicious food, warm hospitality, and plenty of open spaces for children to play and explore, Woodland Escape Resort near Akola ensures every family member experiences joy, relaxation, and togetherness in the heart of nature.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



 "services": [
    {
      "name": "Resorts Near Akola for Family",
      "description": "Woodland Escape Resort is one of the best resorts near Akola for families, offering a perfect mix of relaxation, fun, and nature. Families can enjoy outdoor games, delicious food, nature walks, and peaceful surroundings, making it an ideal destination for bonding and creating lasting memories."
    },
    {
      "name": "Akola Family Resort Stay",
      "description": "Enjoy a comfortable and memorable family resort stay near Akola at Woodland Escape Resort. The resort features cozy accommodations, spacious lawns, and fun-filled activities for all ages. It’s the ideal getaway for families seeking quality time together away from city life."
    },
    {
      "name": "Affordable Family Resorts Akola",
      "description": "Woodland Escape Resort is an affordable family resort near Akola that combines great value with top-notch facilities. Families can enjoy full-day activity packages, meals, and relaxing green spaces without stretching their budget, making it perfect for weekend getaways or one-day trips."
    },
    {
      "name": "Akola Weekend Family Resort",
      "description": "Make your weekends special at Woodland Escape Resort — a family-friendly weekend resort near Akola. Spend time engaging in fun games, exploring nature, and relaxing by the riverside. The resort’s peaceful environment and variety of activities ensure a perfect family retreat."
    },
    {
      "name": "Akola Kids Friendly Resort",
      "description": "Woodland Escape Resort is a kids-friendly resort near Akola, offering safe play areas, adventure zones, and outdoor activities specially designed for children. Parents can unwind while kids enjoy nature exploration, mini obstacle games, and interactive experiences in a secure environment."
    },
    {
      "name": "Akola Family Outing Resort",
      "description": "Plan your next family outing near Akola at Woodland Escape Resort. The resort offers picnic spaces, adventure activities, and delicious meals for families looking to spend a fun-filled day together in the lap of nature. It’s ideal for weekend getaways, birthdays, or reunions."
    },
    {
      "name": "Akola Nature Resort for Families",
      "description": "Reconnect with nature at Woodland Escape Resort, a peaceful nature resort near Akola perfect for families. Surrounded by greenery, the resort provides walking trails, picnic areas, and organic experiences where families can relax and rejuvenate together."
    },
    {
      "name": "Akola Riverside Family Resort",
      "description": "Woodland Escape Resort is a beautiful riverside family resort near Akola, offering stunning views and a calm ambiance. Families can enjoy riverside picnics, outdoor games, and peaceful relaxation by the water. It’s a great way to enjoy nature while spending quality time together."
    },
    {
      "name": "Akola Hill Resort for Family",
      "description": "For those seeking a cool and scenic escape, Woodland Escape Resort serves as an excellent hill resort for families near Akola. The mild elevation, greenery, and fresh air make it perfect for a relaxed family trip, complete with fun outdoor activities and sightseeing."
    },
    {
      "name": "Akola Family Picnic Resort",
      "description": "Woodland Escape Resort is a top family picnic resort near Akola, ideal for one-day visits filled with fun and relaxation. Families can set up picnic spots, enjoy open-air meals, and participate in outdoor games amidst a safe and natural environment."
    },
    {
      "name": "Akola Outdoor Resort for Families",
      "description": "Enjoy the open spaces of Woodland Escape Resort — a top outdoor resort for families near Akola. With spacious lawns, adventure activities, and plenty of sunshine, it’s a wonderful destination for those who love the outdoors and want to escape the city’s hustle and bustle."
    },
    {
      "name": "Akola Family Resort Booking",
      "description": "Booking your family resort experience near Akola is easy at Woodland Escape Resort. Choose from one-day packages or weekend stays that include meals, activities, and accommodation options designed for families of all sizes and age groups."
    },
    {
      "name": "Akola Group Family Resort",
      "description": "Woodland Escape Resort welcomes large family groups from Akola for reunions, celebrations, and get-togethers. With open picnic lawns, group games, and customized dining options, it’s the perfect destination for big families seeking a memorable shared experience."
    },
    {
      "name": "Akola One Day Family Resort",
      "description": "For a one-day family resort trip near Akola, Woodland Escape Resort is the perfect destination. Families can arrive in the morning, enjoy activities and delicious meals, and return home refreshed after a day of fun in the countryside."
    },
    {
      "name": "Akola Luxury Family Resort",
      "description": "Experience comfort and class at Woodland Escape Resort, a luxury family resort near Akola. The resort combines modern amenities with natural charm, offering spacious cottages, fine dining, and beautiful landscapes that provide an unforgettable family experience."
    }
  ],
  "tableData": [
    ["- Resorts Near Akola for Family", "- Akola Family Resort Stay"],
    ["- Affordable Family Resorts Akola", "- Akola Weekend Family Resort"],
    ["- Akola Kids Friendly Resort", "- Akola Family Outing Resort"],
    ["- Akola Nature Resort for Families", "- Akola Riverside Family Resort"],
    ["- Akola Hill Resort for Family", "- Akola Family Picnic Resort"],
    ["- Akola Outdoor Resort for Families", "- Akola Family Resort Booking"],
    ["- Akola Group Family Resort", "- Akola One Day Family Resort"],
    ["- Akola Luxury Family Resort", ""]
  ],
  


whychoose: [
  {
    "WhyChooseheading": "Perfect Family Resort Near Akola",
    "WhyChoosedescription": "Woodland Escape Resort is an ideal destination for families near Akola, offering a safe and enjoyable environment surrounded by lush forest. Kids, parents, and grandparents alike can relax, explore, and create lasting memories together in nature."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Family-Friendly Accommodation",
    "WhyChoosedescription": "The resort provides comfortable cottages, forest-view rooms, and picnic zones designed for family comfort. Spacious layouts, cozy seating, and modern amenities ensure everyone feels at home while enjoying the forest surroundings."
  },
  {
    "WhyChooseheading": "Fun Activities for All Ages",
    "WhyChoosedescription": "From nature trails and pondside relaxation to kid-friendly adventure activities like zip-lining and obstacle courses, Woodland Escape Resort offers something for every family member. Everyone can enjoy activities suited to their age and energy level."
  },
  {
    "WhyChooseheading": "Safe and Engaging Outdoor Environment",
    "WhyChoosedescription": "With secure forest trails, supervised play areas, and open spaces for sports or games, parents can relax knowing their children are safe while enjoying the outdoors. The resort’s layout encourages family bonding and outdoor fun."
  },
  {
    "WhyChooseheading": "Tasty and Convenient Meals",
    "WhyChoosedescription": "Families can enjoy fresh, wholesome meals prepared from locally sourced ingredients. Woodland Escape Resort provides picnic-friendly snacks and full meals, making it easy to dine together without leaving the forest setting."
  },
  {
    "WhyChooseheading": "Perfect for Group or Extended Family Outings",
    "WhyChoosedescription": "Whether it’s a small family day out or a gathering with relatives, Woodland Escape Resort accommodates groups of all sizes. Its expansive grounds and activity options ensure a fun and cohesive experience for everyone."
  },
  {
    "WhyChooseheading": "Easy Accessibility from Akola",
    "WhyChoosedescription": "Located just a short drive from Akola, Woodland Escape Resort is easily reachable for day trips or overnight stays. Its convenient location allows families to maximize their time enjoying nature without long travel."
  }
]










  
  



  }

const faqData = [
  {
    question: "Why is Woodland Escape Resort ideal for families near Akola?",
    answer: "Woodland Escape Resort offers a safe, peaceful, and activity-rich environment perfect for family outings. From open lawns and nature trails to recreational activities for all age groups, families can enjoy a memorable stay close to Akola."
  },
  {
    question: "How far is Woodland Escape Resort from Akola?",
    answer: "The resort is about 35–40 km from Akola, roughly a 1 to 1.5-hour drive. Its convenient location makes it easy for families to reach for day trips or weekend stays."
  },
  {
    question: "What family-friendly activities are available at the resort?",
    answer: "The resort offers a variety of activities for families including nature walks, boating, cycling, outdoor games, and kid-friendly play areas. Adults can also relax and enjoy the scenic surroundings while children are engaged safely."
  },
  {
    question: "Are accommodations suitable for families?",
    answer: "Yes! Woodland Escape Resort provides comfortable cottages and rooms that can accommodate families of different sizes. The rooms are designed for comfort while keeping you close to nature."
  },
  {
    question: "Does the resort provide meals for families?",
    answer: "Yes, the resort serves freshly prepared meals including vegetarian and non-vegetarian options. Picnic-style lunches, snacks, and beverages are also available to make the family stay convenient and enjoyable."
  },
  {
    question: "How can we book a family stay at Woodland Escape Resort?",
    answer: "You can book by calling or WhatsApp messaging our reservations team, or visiting our official website. Advance booking is recommended, especially during weekends and holidays, to ensure availability."
  }
];

const testimonials = [
  {
    name: "Mr. Sameer & Family, Akola",
    text: "We had a wonderful family stay at Woodland Escape Resort! The kids loved the play areas, and the adults enjoyed the peaceful surroundings. The food was delicious and the staff very helpful. Truly one of the best family resorts near Akola."
  },
  {
    name: "Miss. Priya & Family, Akola",
    text: "Woodland Escape Resort made our weekend stay memorable! The rooms were comfortable, the environment scenic, and there were plenty of activities for everyone. A perfect family getaway near Akola."
  }
];









      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Resorts Near Akola for Family",
  "image": "https://woodlandescape.com/assets/images/resorts-near-akola-for-family.jpg",
  "description": "Plan a perfect family getaway at Woodlandescape Resort — one of the best resorts near Akola for families. Enjoy nature, kids-friendly activities, outdoor fun, and comfortable stays for a memorable weekend with loved ones.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "923"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/resorts-near-akola-for-family"
  }
};



  return (
    <div>
<Helmet>
  <title>Resorts Near Akola for Family | Kids Friendly & Scenic Stay | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Enjoy a fun-filled family stay at Woodlandescape Resort — one of the top resorts near Akola for families. Perfect for kids-friendly activities, outdoor fun, scenic nature, and comfortable weekend getaways." 
  />
  <meta 
    name="keywords" 
    content="Resorts Near Akola for Family, Akola Family Resort Stay, Affordable Family Resorts Akola, Akola Weekend Family Resort, Akola Kids Friendly Resort, Akola Family Outing Resort, Akola Nature Resort for Families, Akola Riverside Family Resort, Akola Hill Resort for Family, Akola Family Picnic Resort, Akola Outdoor Resort for Families, Akola Family Resort Booking, Akola Group Family Resort, Akola One Day Family Resort, Akola Luxury Family Resort" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/11.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Resortnearakolaforfamily;